// chakra imports
import {
  Avatar,
  Box,
  Divider,
  Flex,
  Icon,
  List,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Stack,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../../../firebase';
import { MdPersonOutline, MdLogout } from 'react-icons/md';
//   Custom components
import Brand from 'components/sidebar/components/Brand';
import Links from 'components/sidebar/components/Links';

// FUNCTIONS

function SidebarContent(props) {
  const { routes, mini, hovered } = props;
  const navigate   = useNavigate();
  // Sidebar sempre dark — texto sempre claro
  const textColor  = 'white';
  const subColor   = 'whiteAlpha.700';
  const hoverBg    = 'whiteAlpha.100';
  const menuBg     = useColorModeValue('white', 'navy.800');
  const borderColor = useColorModeValue('#E6ECFA', 'rgba(135,140,189,0.3)');
  const shadow     = useColorModeValue(
    '14px 17px 40px 4px rgba(112,144,176,0.18)',
    '14px 17px 40px 4px rgba(112,144,176,0.06)',
  );

  const [userProfile, setUserProfile] = useState(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const snap = await getDoc(doc(db, 'users', user.uid));
        if (snap.exists()) setUserProfile({ uid: user.uid, email: user.email, ...snap.data() });
        else setUserProfile({ uid: user.uid, email: user.email });
      }
    });
    return () => unsub();
  }, []);

  const showLabel = mini === false || hovered === true;
  const fullName  = [userProfile?.firstName, userProfile?.lastName].filter(Boolean).join(' ') || userProfile?.email || 'Usuário';

  return (
    <Flex direction="column" height="100%" pt="25px" borderRadius="0">
      <Brand mini={mini} hovered={hovered} />
      <Stack direction="column" mb="auto" mt="8px">
        <Box
          ps={
            mini === false
              ? '20px'
              : mini === true && hovered === true
              ? '20px'
              : '16px'
          }
          pe={{ md: '16px', '2xl': '1px' }}
          ms={mini && hovered === false ? '-16px' : 'unset'}
        >
          <List spacing={0}>
            <Links mini={mini} hovered={hovered} routes={routes} />
          </List>
        </Box>
      </Stack>

      {/* Perfil do usuário */}
      <Box px={showLabel ? '16px' : '8px'} pb="20px" pt="8px">
        <Divider mb="12px" opacity={0.3} />
        <Menu placement="top-start">
          <MenuButton
            w="100%"
            borderRadius="12px"
            p={showLabel ? '8px 10px' : '8px'}
            _hover={{ bg: hoverBg }}
            transition="all 0.2s"
          >
            <Flex align="center" gap="10px">
              <Avatar
                size="sm"
                name={fullName}
                bg="orange.400"
                color="white"
                flexShrink={0}
              />
              {showLabel && (
                <Box textAlign="left" overflow="hidden">
                  <Text fontSize="sm" fontWeight="600" color={textColor} noOfLines={1}>
                    {fullName}
                  </Text>
                  <Text fontSize="xs" color={subColor} noOfLines={1}>
                    {userProfile?.email || ''}
                  </Text>
                </Box>
              )}
            </Flex>
          </MenuButton>
          <MenuList
            bg={menuBg}
            border="none"
            boxShadow={shadow}
            borderRadius="14px"
            p="8px"
            minW="180px"
          >
            <MenuItem
              icon={<Icon as={MdPersonOutline} boxSize="16px" />}
              borderRadius="8px"
              fontSize="sm"
              onClick={() => navigate(`/admin/main/users/settings/${userProfile?.uid}`)}
            >
              Editar Perfil
            </MenuItem>
            <MenuItem
              icon={<Icon as={MdLogout} boxSize="16px" />}
              borderRadius="8px"
              fontSize="sm"
              color="red.400"
              onClick={async () => { await signOut(auth); navigate('/auth/sign-in/default'); }}
            >
              Sair
            </MenuItem>
          </MenuList>
        </Menu>
      </Box>
    </Flex>
  );
}

export default SidebarContent;
